import * as yup from "yup";

const customizationSchema = (props) => {
  const SUPPORTED_TARGET_FORMATS = ["image/jpg", "image/jpeg"];
  const SUPPORTED_VIDEO_FORMATS = ["video/mp4"];
  const SUPPORTED_ASSET_FORMATS = [
    "zip,application/octet-stream",
    "application/zip",
    "application/x-zip",
    "application/x-zip-compressed",
  ];
  const IMAGE_SIZE = 4000 * 1024; // 4MB
  const VIDEO_SIZE = 20000 * 1024; // 20MB
  const ASSET_SIZE = 50000 * 1024; // 50MB

  const schema = yup.object().shape({
    contentStyle: yup.string().nullable().required(),
    freemium: yup.string().nullable().required(),
    thumbnail: yup
      .mixed()
      .test(
        "fileFormat",
        "select a valid file: .jpg or .jpeg",
        function (value) {
          if (!value.length) return false; // attachment is required
          return SUPPORTED_TARGET_FORMATS.includes(value[0].type);
        }
      )
      .test("fileSize", "File too large", function (value) {
        if (!value.length) return false; // attachment is required
        return value[0].size <= IMAGE_SIZE;
      }),
    gif: yup
      .mixed()
      .test("fileFormat", "select a valid file: .mp4", function (value) {
        if (!value.length) return false; // attachment is required
        return SUPPORTED_VIDEO_FORMATS.includes(value[0].type);
      })
      .test("fileSize", "File too large", function (value) {
        if (!value.length) return false; // attachment is required
        return value[0].size <= VIDEO_SIZE;
      }),
    marker: yup
      .mixed()
      .test(
        "fileFormat",
        "select a valid file: .jpg or .jpeg",
        function (value) {
          if (!value.length) return false; // attachment is required
          return SUPPORTED_TARGET_FORMATS.includes(value[0].type);
        }
      )
      .test("fileSize", "File too large", function (value) {
        if (!value.length) return false; // attachment is required
        return value[0].size <= IMAGE_SIZE;
      }),
    video: yup.string(),
    //.mixed()
    // .test("fileFormat", "select a valid video file: .mp4", function (value) {
    //   if (!value.length) return false; // attachment is required
    //   return SUPPORTED_VIDEO_FORMATS.includes(value[0].type);
    // })
    // .test("fileSize", "File too large", function (value) {
    //   if (!value.length) return false; // attachment is required
    //   return value[0].size <= VIDEO_SIZE;
    // }),
    bundleAppStore: yup
      .mixed()
      .test(
        "fileFormat",
        "select a valid file: .zip with .assetbundle inside it",
        function (value) {
          if (!value.length) return false; // attachment is required
          return SUPPORTED_ASSET_FORMATS.includes(value[0].type);
        }
      )
      .test("fileSize", "AssetBundle too large", function (value) {
        if (!value.length) return false; // attachment is required
        return value[0].size <= ASSET_SIZE;
      }),
    bundlePlayStore: yup
      .mixed()
      .test(
        "fileFormat",
        "select a valid file: .zip with .assetbundle inside it",
        function (value) {
          if (!value.length) return false; // attachment is required
          return SUPPORTED_ASSET_FORMATS.includes(value[0].type);
        }
      )
      .test("fileSize", "AssetBundle too large", function (value) {
        if (!value.length) return false; // attachment is required
        return value[0].size <= ASSET_SIZE;
      }),
  });
  return schema;
};

export { customizationSchema };
